import {
  init as Sentry,
  replayIntegration,
  captureConsoleIntegration
  // reactRouterV6BrowserTracingIntegration
} from '@sentry/react';

/* import {
  useLocation,
  matchRoutes,
  BrowserRouter,
  useNavigationType,
  createRoutesFromChildren
} from 'react-router-dom'; */

import '@/styles/index.css';
import Store from '@/redux';
// import { useEffect } from 'react';
import { Provider } from 'react-redux';
import Application from '@/Application';
import { createRoot } from 'react-dom/client';
import { showConsole } from '@/utils/Location';
import { BrowserRouter } from 'react-router-dom';
import { sentryDSN, reCAPTCHA } from '@/utils/API';
import { LazyMotion, domAnimation } from 'motion/react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

~showConsole() &&
  !!sentryDSN &&
  Sentry({
    tracePropagationTargets: [`${import.meta.env.VITE_API_BASE_URL}/api`],
    tracesSampleRate: +import.meta.env.VITE_SENTRY_SAMPLE_RATE || 0.0,
    environment: import.meta.env.MODE,
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
    dsn: sentryDSN,

    integrations: [
      replayIntegration(),

      captureConsoleIntegration({
        levels: import.meta.env.VITE_SENTRY_LOG_CAPTURE_LEVELS?.split(', ')
      })

      /* reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }) */
    ],

    ignoreErrors: [
      'Non-Error promise rejection captured',
      'McD Bridge already initialized',
      'Non-Error exception captured'
    ]
  });

const ApplicationWrapper = (
  <LazyMotion features={domAnimation} strict>
    <Provider store={Store}>
      <BrowserRouter>
        <Application />
      </BrowserRouter>
    </Provider>
  </LazyMotion>
);

createRoot(document.body).render(
  reCAPTCHA ? (
    <GoogleReCaptchaProvider reCaptchaKey={reCAPTCHA} useEnterprise>
      {ApplicationWrapper}
    </GoogleReCaptchaProvider>
  ) : (
    ApplicationWrapper
  )
);
